var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 20,
    viewBox: "0 0 27 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.885 6.0577C14.885 4.4511 14.2468 2.9103 13.1107 1.77426C11.9747 0.63822 10.4339 0 8.82729 0C7.22069 0 5.67989 0.63822 4.54385 1.77426C3.40781 2.9103 2.76959 4.4511 2.76959 6.0577C2.76959 7.61816 2.98975 9.91247 5.19267 12.1154L14.885 19.3846C14.885 19.3846 22.3744 14.3183 24.5773 12.1154C26.7802 9.91247 27.0004 7.61816 27.0004 6.0577C27.0004 4.4511 26.3622 2.9103 25.2261 1.77426C24.0901 0.63822 22.5493 0 20.9427 0C19.3361 0 17.7953 0.63822 16.6592 1.77426C15.5232 2.9103 14.885 4.4511 14.885 6.0577Z",
    fill: "#0C1331"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1154 6.0577C12.1154 4.4511 11.4772 2.9103 10.3411 1.77426C9.2051 0.63822 7.6643 0 6.0577 0C4.4511 0 2.9103 0.63822 1.77426 1.77426C0.63822 2.9103 0 4.4511 0 6.0577C0 7.61816 0.220154 9.91247 2.42308 12.1154L12.1154 19.3846C12.1154 19.3846 19.6048 14.3183 21.8077 12.1154C24.0106 9.91247 24.2308 7.61816 24.2308 6.0577C24.2308 4.4511 23.5926 2.9103 22.4565 1.77426C21.3205 0.63822 19.7797 0 18.1731 0C16.5665 0 15.0257 0.63822 13.8897 1.77426C12.7536 2.9103 12.1154 4.4511 12.1154 6.0577Z",
    fill: "#E4E424"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.0058fa2b97bd879761739376cc97d093.svg";
export { ForwardRef as ReactComponent };